module.exports = __webpack_public_path__ + "static/media/Sample1.fb362de2.jpg";